<template>
  <div class="row mt-4">
    <div class="col-12">
      <draggable
        :list="coursesList"
        @change="initiateUpdateOrder"
        handle=".grabbable"
      >
        <div
          class="d-flex align-items-center mb-3 bg-light"
          v-for="course in coursesList"
          :key="course.id"
        >
          <div class="ms-3 d-none d-md-block">
            <i class="fas fa-bars grabbable"></i>
          </div>
          <div class="mx-3">
            <PublisToggle :course="course"></PublisToggle>
          </div>
          <div style="max-width: 150px;" class="d-none d-md-block">
            <img
              class="img-fluid"
              :src="
                `https://djceg34j53tq.cloudfront.net/${course.cover_photo}`
              "
              alt=""
              v-if="course.cover_photo"
            />
            <img
              class="img-fluid"
              src="https://placehold.co/1280x800/E1D4F1/ffffff"
              alt=""
              v-else
            />
          </div>
          <div class="mx-3 w-100 position-relative">
            <div>
              <div class="mb-md-3">
                <a
                  :href="$api.courseEdit(course.id)"
                  class="fw-bold stretched-link"
                >
                  {{ course.title }}
                </a>
              </div>
              <div>
                <small class="text-muted">{{ course.type | translate }}</small>
              </div>
            </div>
          </div>
          <div class="me-3 ms-3 d-flex">
            <div class="dropleft">
              <button
                class="btn btn-link"
                type="button"
                 data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-link"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item"
                  :href="courseSalesPage(course)"
                  target="_blank"
                >
                  {{ 'Sales page' | translate }}
                </a>
                <a
                  class="dropdown-item"
                  :href="courseCheckout(course)"
                  target="_blank"
                >
                  {{ 'Checkout page' | translate }}
                </a>
              </div>
            </div>

            <div class="dropleft">
              <button
                class="btn btn-link"
                type="button"
                 data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" :href="$api.courseEdit(course.id)">
                  {{ 'Edit' | translate }}
                </a>
                <a
                  class="dropdown-item"
                  :href="$api.courseLectureList(course.id)"
                >
                  {{ 'Lecture list' | translate }}
                </a>
                <a
                  v-if="course.sales_page"
                  class="dropdown-item"
                  :href="$api.salesPageEdit(course.sales_page.id)"
                >
                  {{ 'Sales page' | translate }}
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="duplicate(course.id)"
                >
                  {{ 'Duplicate' | translate }}
                </a>
                <a class="dropdown-item" :href="$api.courseLeads(course.id)">
                  {{ 'Leads' | translate }}
                </a>
                <a class="dropdown-item" :href="$api.courseStats(course.id)">
                  {{ 'Engagement' | translate }}
                </a>
                <div class="dropdown-divider"></div>
                <Delete class-name="dropdown-item" :course="course"></Delete>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import PublisToggle from './PublishToggle'
import Delete from './DeleteV1'
import draggable from 'vuedraggable'
import _ from 'lodash'

export default {
  components: {
    PublisToggle,
    draggable,
    Delete,
  },
  props: ['courses'],
  data() {
    return {
      coursesList: this.courses,
    }
  },
  methods: {
    courseSalesPage(course) {
      return `${window.location.protocol}//${_.get(course, 'page.domain')}/${course.slug}`
    },
    courseCheckout(course) {
      return `${window.location.protocol}//${_.get(course, 'page.domain')}/${course.slug}/checkout`
    },
    duplicate(id) {
      this.$api
        .courseDuplicate(id)
        .then(({ data }) => {
          this.coursesList.push(data)
          iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    initiateUpdateOrder(e) {
      if (e.moved) {
        this.updateOrder(this.coursesList).then((response) => {
          iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
        })
      }
    },
    updateOrder(courses) {
      courses.map((course, i) => {
        course.sort_order = i
      })

      let data = _.sortBy(courses, (course) => course.id)

      return this.$api.coursesOrder(data)
    },
  },
}
</script>
